import { render } from "./SCLImport.vue?vue&type=template&id=3bfa5539&scoped=true"
import script from "./SCLImport.vue?vue&type=script&lang=js"
export * from "./SCLImport.vue?vue&type=script&lang=js"

import "./SCLImport.vue?vue&type=style&index=0&id=3bfa5539&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bfa5539"]])

export default __exports__